module.exports = __webpack_public_path__ + "media/leave-button.bed87372.wav";